 export enum EnumQuoteServiceType {
    SAS = 'SAS',
    FON = 'FON',
    SOL = 'SOL',
    DASRI = 'DASRI',
    CAF = 'CAF',
    VT = 'VT',
    LS = 'LS',
    THREE_D = '3D'
}
